import {clsx} from 'clsx';

type InputProps = {
	text: string;
	name: string;
	type?: string;
	register?: any;
	error?: string;
	className?: string;
	inputClass?: string;
	isRequired?: boolean;
	value?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	inputRef?: React.RefObject<HTMLInputElement>;
};

export function Input({
	text,
	name,
	register,
	type = 'text',
	error,
	className,
	inputClass,
	isRequired = false,
	onKeyPress,
	inputRef
}: InputProps) {
	const inputId = `input-${name}`;

	return (
		<div className={clsx('w-full h-full', className)}>
			<div className="relative">
				<input
					ref={inputRef ?? register?.ref}
					id={inputId}
					placeholder=""
					className={clsx(
						'peer w-full bg-white h-[56px] placeholder:text-transparent text-blue text-sm outline outline-1 focus:outline-2 rounded-[6px] px-3 py-2 transition duration-300 ease',
						error
						? 'outline-error focus:outline-error hover:outline-error outline-2'
						: 'outline-gray-300 focus:outline-blue hover:outline-gray-300 hover:outline-2',
						inputClass
					)}
					{...(register ?? {})}
					name={name}
					type={type}
					onKeyPress={onKeyPress}
				/>
				<label
					htmlFor={inputId}
					className={clsx(
						'absolute cursor-text bg-white rounded-l px-1 left-2.5 text-[16px] transition-all transform origin-left',
						'peer-placeholder-shown:top-[16px] peer-placeholder-shown:text-[16px] peer-placeholder-shown:scale-90',
						'peer-focus:-top-2 peer-focus:left-2.5 peer-focus:text-sm peer-focus:scale-90',
						'-top-2 scale-90 text-sm',
						error ? 'text-error peer-focus:text-error' : 'text-blue peer-focus:text-blue'
					)}
				>
					{text}
					{isRequired ? ' *' : ''}
				</label>
				{error && (
					<p className="mt-[6px] px-[16px] text-[12px] text-error leading-3">
						{error}
					</p>
				)}
			</div>
		</div>
	);
}

